import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import settings from "src/devices/all/settings";

class LikesServiceTask extends AbstractRequestTask {
	constructor(params = {
		method: 'GET',
		like: 1,
		stars: undefined,
		group_id: null,
		group_uid: null,
	}) {
		super();

		this.method = (params.method || 'GET').toUpperCase();
		this.like = params.like;
		this.stars = params.stars;
		this.groupId = params.group_id;
		this.groupUid = params.group_uid;

		this.params = super.getParams();
    	this.user_token = this.params.user_token;
	}

	getMethod() {
		return this.method;
	}

	getEncType() {
		return 'application/json';
	}

	getHeaders() {
		const params = super.getParams();
		return {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${this.user_token}`,
		};
	}

	getUrl() {
		const http = "https://";
		const url = Launcher.get("akamai_mfwk");
		return `${http}${url}/likes/v1/like`;
	}

	getGroupParams(sendNullValues = false) {
		if (sendNullValues) {
			return {
				group_id: this.groupId || null,
				group_uid: this.groupUid || null,
			};
		}

		const groupParams = {};

		if (this.groupId !== undefined && this.groupId !== null && this.groupId !== '') {
			groupParams.group_id = this.groupId;
		}

		if (this.groupUid !== undefined && this.groupUid !== null && this.groupUid !== '') {
			groupParams.group_uid = this.groupUid;
		}

		return groupParams;
	}

	getParams() {
		const params = super.getParams();

		delete params.HKS;
		delete params.user_token;
		delete params.api_version;

		if (this.method === 'POST') {
			const requestBody = {
				like: this.like,
				...this.getGroupParams(true),
			};

			if (this.stars !== undefined) {
				requestBody.stars = this.stars;
			}

			return requestBody;
		}

		return {
			...params,
			...this.getGroupParams(),
		};
	}

	success(data, b) {
		this.resolve(data);
	}

	getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default LikesServiceTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/likes/LikesServiceTask.js